export { default as closest } from './closest';
export { default as delegate } from './delegate';
export { default as dispatch } from './dispatch';
export { default as getAttributes } from './get-attributes';
export { default as matches } from './matches';
export { default as parents } from './parents';
export { default as parseUrl } from './parse-url';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@aws-amplify/analytics/lib-esm/vendor/dom-utils/index.js
// module id = 1311
// module chunks = 0